<div class="container-fluid">
    <app-report reportId="mxmiddlewareDashboard" screen="MKMIDDLEWAREDASHBOADR"></app-report>
  </div>

